(function(){
Array.prototype.forEach.call(document.querySelectorAll('.qvh'),function(root){
  var $=function(s){return root.querySelector(s)},$$=function(s){return Array.prototype.slice.call(root.querySelectorAll(s))};
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var rail=$('#rail');
  if(rail){$$('.qvh-arrows button').forEach(function(b){b.addEventListener('click',function(){rail.scrollBy({left:(+b.dataset.dir)*300,behavior:'smooth'});});});}
  var pane=$('#tabpane');
  if(pane){
    var tabimgs=JSON.parse(root.getAttribute('data-tabimgs')||'[]');
    var tabtext=JSON.parse(root.getAttribute('data-tabtext')||'[]');
    var tabs=tabtext.map(function(t,i){return {h:t.h,p:t.p,img:tabimgs[i]};});
    var btns=$$('.qvh-tabs button');
    btns.forEach(function(b){b.addEventListener('click',function(){
      btns.forEach(function(x){x.setAttribute('aria-selected','false');});
      b.setAttribute('aria-selected','true');
      var t=tabs[+b.dataset.i];
      $('#tabh').innerHTML=t.h;$('#tabp').innerHTML=t.p;if(t.img)$('#tabimg').src=t.img;
      pane.classList.remove('qvh-swap');void pane.offsetWidth;pane.classList.add('qvh-swap');
    });});
  }
  root.classList.add('qvh-js');
  var sel='.qvh-rail-head, .qvh-card, .qvh-manifesto .qvh-wrap > *, .qvh-panel .qvh-txt, .qvh-pack .qvh-wrap > *, .qvh-pack .qvh-shelf img, .qvh-split .qvh-txt > *, .qvh-essence .qvh-txt > *, .qvh-sys .qvh-wrap > p, .qvh-sys h2, .qvh-tabs, .qvh-tabpane, .qvh-sys-cta, .qvh-mini .qvh-wrap > p, .qvh-mini h2, .qvh-tile, .qvh-faq .qvh-aside > *, .qvh-faq details';
  var els=$$(sel);
  els.forEach(function(el){var i=0,n=el;while((n=n.previousElementSibling)&&n.hasAttribute('data-reveal'))i++;el.setAttribute('data-reveal','');el.style.setProperty('--d',Math.min(i,8));});
  if('IntersectionObserver' in window && !reduce){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting||e.boundingClientRect.top<0){e.target.classList.add('qvh-in');io.unobserve(e.target);}});},{rootMargin:'0px 0px -8% 0px',threshold:.08});
    els.forEach(function(el){io.observe(el);});
  } else {els.forEach(function(el){el.classList.add('qvh-in');});}
  var hv=$('#herovideo'),hp=$('#heropause'),hi=$('#heroicon');
  if(hv&&hp&&hi){
    var PAUSE='\u275A\u275A',PLAY='\u25B6';
    var setIcon=function(){var paused=hv.paused;hi.textContent=paused?PLAY:PAUSE;hp.setAttribute('aria-label',paused?(root.getAttribute('data-lplay')||''):(root.getAttribute('data-lpause')||''));};
    if(reduce){hv.removeAttribute('autoplay');hv.pause();}
    var p=hv.play&&hv.play(); if(p&&p.catch)p.catch(function(){});
    hp.addEventListener('click',function(){ if(hv.paused){hv.play();} else {hv.pause();} setIcon(); });
    hv.addEventListener('play',setIcon);hv.addEventListener('pause',setIcon);setIcon();
  }
  var floats=$$('.qvh-manifesto .qvh-float');
  if(!reduce&&floats.length){var tick=false;var px=function(){var vh=window.innerHeight;floats.forEach(function(f,k){var r=f.closest('section').getBoundingClientRect();var y=(r.top+r.height/2-vh/2)*(k?-.09:.07);f.style.transform='translateY('+y.toFixed(1)+'px) rotate('+(k?11:-10)+'deg)';});tick=false;};
    window.addEventListener('scroll',function(){if(!tick){tick=true;requestAnimationFrame(px);}},{passive:true});px();}
});
})();
